<template>
  <RecentVisitListLayout
    title="Ближайшие посещения"
    :buttons="buttons"
    :sections="usersVisits.upcomingVisits?.length ? 3 : 1"
    :class="{'no-list-data': !usersVisits.upcomingVisits?.length}"
  >
    <template v-if="usersVisits.upcomingVisits?.length">
      <event-card
        v-for="(visit, num) in usersVisits.upcomingVisits"
        :key="visit"
        :animation-delay="num - 1"
        :doctor-name="`${visit.firstname ?? ''} ${visit.lastname ?? ''} ${
        visit.secondname ?? ''
      }`"
        :spec-name="visit.spec"
        :event-date="visit.dat_bgn.split(' ')[0]"
        :event-time="visit.dat_bgn.split(' ')[1]"
        :number="visit.rnumb_id"
      ></event-card>
    </template>
    <h4 v-else class="h2 adaptive color-dark w-100">
      Нет запланированных посещений
    </h4>
  </RecentVisitListLayout>
</template>

<script>
import EventCard from "@/components/cards/EventCard.vue";
import RecentVisitListLayout from "@/layouts/RecentVisitListLayout.vue";
import { useUserVisitsStore } from "@/store/userVisits";
import { onBeforeMount } from "vue";
import { useRouter } from "vue-router";
export default {
  name: "UserUpcomingVisits",
  components: {
    EventCard,
    RecentVisitListLayout,
  },
  setup() {
    const usersVisits = useUserVisitsStore();
    const router = useRouter();
    onBeforeMount(() => {
      usersVisits.getUpcomingVisits();
    });

    return {
      usersVisits,
      buttons: [
        {
          title: "Все запланированные посещения",
          onClick: () => {
            router.push("/future-visits");
          },
        },
      ],
    };
  },
};
</script>

<style scoped></style>
